import { cn, Input } from '@heroui/react'
import { Field, FieldProps } from 'formik'
import { motion } from 'framer-motion'
import { ChangeEvent, useState } from 'react'

interface FileInfo {
  name: string
  size: number
  type: string
}

export interface FileInputFormikProps {
  label: string
  classNameContainer?: string
  name: string
  accept?: string
  multiple?: boolean
  maxSize?: number // in MB
  onChange?: (files: FileList | null) => void
}

const FileInputFormik = ({
  label,
  classNameContainer,
  accept,
  multiple = false,
  maxSize = 5,
  onChange,
  ...props
}: FileInputFormikProps) => {
  const [error, setError] = useState<string>('')
  const [fileInfo, setFileInfo] = useState<FileInfo[]>([])

  // const formatFileSize = (bytes: number): string => {
  //   if (bytes === 0) return "0 Bytes";
  //   const k = 1024;
  //   const sizes = ["Bytes", "KB", "MB", "GB"];
  //   const i = Math.floor(Math.log(bytes) / Math.log(k));
  //   return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
  // };

  const validateFiles = (files: FileList | null): boolean => {
    if (!files) return false

    for (let i = 0; i < files.length; i++) {
      const file = files[i]

      if (file.size > maxSize * 1024 * 1024) {
        setError(`File size should not exceed ${maxSize}MB`)

        return false
      }
    }

    setError('')

    return true
  }

  const handleFileChange = (e: ChangeEvent<HTMLInputElement>, form: FieldProps['form']) => {
    const files = e.target.files

    if (validateFiles(files)) {
      form.setFieldValue(props.name, files)
      onChange?.(files)

      if (files) {
        const newFileInfo: FileInfo[] = Array.from(files).map(file => ({
          name: file.name,
          size: file.size,
          type: file.type,
        }))

        setFileInfo(newFileInfo)
      }
    } else {
      e.target.value = ''
      form.setFieldValue(props.name, null)
      setFileInfo([])
    }
  }

  return (
    <Field name={props.name}>
      {({ meta, form }: FieldProps) => (
        <motion.div className={cn(classNameContainer, 'relative')}>
          {fileInfo.length > 0 && (
            <div className="absolute top-7 right-0 text-sm">
              <span>{fileInfo[0].name}</span>
            </div>
          )}
          <div className="absolute top-6 z-50 left-4 w-4 h-4 gap-4">{/* <FileIcon/> */}</div>
          <Input
            accept={accept}
            className="h-full w-full fill-input scale-100"
            isInvalid={!!(meta.error && meta.touched) || !!error}
            label={label}
            multiple={multiple}
            type="file"
            variant="underlined"
            onChange={(e: ChangeEvent<HTMLInputElement>) => handleFileChange(e, form)}
            {...props}
            errorMessage={error || (meta.error && meta.touched ? meta.error : '')}
            classNames={{
              input: 'opacity-0',
              label: fileInfo.length == 0 && '!translate-y-0 !scale-100 !text-foreground-500',
            }}
          />
        </motion.div>
      )}
    </Field>
  )
}

export default FileInputFormik
